import { ConnectServicesEnvironment, defaultEnvironment } from '@connect-services/client/environments/default';
import { EnvironmentNameEnum } from '@shared/client/models/environment.interface';

export const environment: ConnectServicesEnvironment = {
    ...defaultEnvironment,
    baseApiUrl: 'https://api.staging.connect-services.app',
    baseWebsocketUrl: 'wss://notification.staging.connect-services.app:3001',
    env: EnvironmentNameEnum.STAGING,
    production: true,
};
